/*@flow*/
import useQueryParams from './useQueryParams';
import getBbox from 'lib/getBbox';

export default function useBbox(): any {
  const worldBounds = '-90,-180,90,180';
  const bbox = useQueryParams().getIn(['filter', 'bbox']);
  return bbox || getBbox() || worldBounds;
}
